import { api } from "@/lib/api";

// Sube un archivo por partes (chunks) para evitar el tope de tamaño del proxy/Cloudflare.
// Funciona para archivos pequeños y grandes (hasta ~1 GB).
// Devuelve { token, name, mime, size }. onProgress(pct) reporta 0-100.
export async function uploadFileChunked(file, { onProgress } = {}) {
  const init = await api.post("/uploads/init", {
    filename: file.name,
    content_type: file.type || "application/octet-stream",
    size: file.size,
  });
  const uploadId = init.data.upload_id;
  const chunkSize = init.data.chunk_size || 8 * 1024 * 1024;
  const total = Math.max(1, Math.ceil(file.size / chunkSize));
  let sent = 0;
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunkSize, Math.min(file.size, (i + 1) * chunkSize));
    const fd = new FormData();
    fd.append("index", i);
    fd.append("chunk", blob, "chunk");
    await api.post(`/uploads/${uploadId}/chunk`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 300000,
    });
    sent += blob.size;
    if (onProgress) onProgress(Math.min(99, Math.round((sent / (file.size || 1)) * 100)));
  }
  const fin = await api.post(`/uploads/${uploadId}/finalize`, {}, { timeout: 900000 });
  if (onProgress) onProgress(100);
  return fin.data;
}
